import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import {
  sendAppletFeedback,
  fetchAppletFeedbackByUser,
} from "shared/lib/graphql"

import "./applet_feedback.scss"

const opinions = [
  "It is not useful.",
  "It is too slow. ",
  "It does not work as I expected.",
]

const opinionCodes = ["not_useful", "too_slow", "unexpected"]

export default class AppletFeedback extends React.Component {
  state = {
    like: null,
    opinionCode: "",
    suggestionText: "",
    submitted: false,
    backgroundSubmitted: false,
    userRating: null,
  }

  componentDidMount() {
    fetchAppletFeedbackByUser(this.props.appletId)
      .then(data => {
        this.setState({ userRating: data.applet_feedback_by_user })
      })
      .catch(err => console.log(err))
  }

  postPartialFeedback = () => {
    const { userRating } = this.state
    const { like, submitted, backgroundSubmitted } = this.state
    if (
      (userRating === null || userRating !== like) &&
      !submitted &&
      !backgroundSubmitted &&
      like !== null
    ) {
      this.setState({ backgroundSubmitted: true })
      this.postFeedback(null, false /* don't mark the form submitted */)
    }
  }

  postFeedback = (e, markSubmitted = true) => {
    if (e) e.preventDefault()
    const { like, opinionCode, suggestionText } = this.state
    sendAppletFeedback(
      this.props.appletId,
      like,
      opinionCode,
      suggestionText.trim().slice(0, 255)
    )
      .then(() => {
        if (markSubmitted) this.setState({ submitted: true })
      })
      .catch(err => console.log(err))
  }

  handleLike = rating => {
    this.setState(
      {
        like: rating,
        opinionCode: "",
        suggestionText: "",
      },
      () => {
        // always post the initial response in case the form is not submitted
        this.postPartialFeedback()
        const { bottom } = this.feedbackRef.getBoundingClientRect()
        if (bottom > window.innerHeight) {
          this.feedbackRef.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })
        }
      }
    )
  }

  setOpinionCode = index => {
    this.setState({ opinionCode: opinionCodes[index] })
  }

  updateSuggestionText = event => {
    this.setState({ suggestionText: event.target.value })
  }

  feedbackDialogue() {
    const { like } = this.state

    return (
      <>
        <p className="txt-caption">Do you like this Applet?</p>
        <div styleName="answers">
          <button
            onClick={() => this.handleLike(false)}
            styleName="option"
            className={classnames("button-tertiary", {
              "button-outlined": like == null || like === true,
            })}
          >
            No
          </button>
          <button
            onClick={() => this.handleLike(true)}
            styleName="option"
            className={classnames("button-tertiary", {
              "button-outlined": !like,
            })}
          >
            Yes
          </button>
        </div>
        {like !== null && (
          <div styleName="dialogue">
            {this.renderMultipleChoice(
              !this.state.opinionCode && like === false
            )}
            {this.renderSuggestionBox(like || this.state.opinionCode)}
          </div>
        )}
      </>
    )
  }

  renderMultipleChoice(shouldRender) {
    if (!shouldRender) return

    return (
      <>
        <div styleName="why-not">
          Let the people at {this.props.serviceName} know why.
        </div>
        {opinions.map((code, index) => (
          <div
            styleName="multi-ifttt-next"
            key={index}
            onClick={() => this.setOpinionCode(index)}
          >
            {code}
          </div>
        ))}
      </>
    )
  }

  renderSuggestionBox(shouldRender) {
    if (!shouldRender) return

    const sentiment = this.state.like
      ? "Glad you like it!"
      : "Sorry to hear that."

    return (
      <>
        <div styleName="why-not">{sentiment}</div>
        <div styleName="prompt">
          Do you have any suggestions on how to improve this Applet for the kind
          folks at {this.props.serviceName}?
        </div>
        <form onSubmit={this.postFeedback}>
          <textarea
            styleName="text"
            value={this.state.suggestionText}
            onChange={this.updateSuggestionText}
            placeholder="Suggestions..."
          />
          <input className="button-tertiary" type="submit" value="Submit" />
        </form>
      </>
    )
  }

  renderThanks() {
    return (
      <div>
        <div styleName="why-not">Thank you!</div>
        <p>
          Your suggestion was sent to the creator. Thanks for taking the time to
          help them improve.
        </p>
      </div>
    )
  }

  render() {
    const { submitted, userRating } = this.state
    return (
      <div className="feedback-container" ref={ref => (this.feedbackRef = ref)}>
        <div styleName="feedback-ui">
          {userRating === null &&
            (submitted ? this.renderThanks() : this.feedbackDialogue())}
        </div>
      </div>
    )
  }
}

AppletFeedback.propTypes = {
  appletId: PropTypes.string,
  serviceName: PropTypes.string,
}
